import { ModalWrapper } from '../modal-wrapper'
import { ImpactsModal } from './impacts-modal.component'
import { JourneysModal } from './journeys-modal.component'
import { StepsModal } from './steps-modal.component'
import { ProductsModal } from './products-modal.component'
import { AccountsModal } from './accounts-modal.component'

import { AssociationsType, IFormSelectedImpacts } from 'src/types'
import useStyles from './styles'
import { ImpactsWithActionsModal } from './impacts-with-actions-modal.component'

interface IAssociationModalProps {
  selectedItems?: string[]
  selectedItemsWithAction?: IFormSelectedImpacts[]
  handleSelectItem?: (value: string) => string[] | void
  type?: AssociationsType
  isImageRound?: boolean
  handleSelectItemWithAction?: (value: IFormSelectedImpacts) => void
  showAccountInfo?: boolean
  scanerId?:string
}

interface IModalProps extends IAssociationModalProps {
  open: boolean
  handleCloseModal: () => void
  modalContentNode?: React.ReactNode
}

const AssociationsModal = ({ open, handleCloseModal, modalContentNode, ...props }: IModalProps) => {
  const classes = useStyles({})

  return (
    <ModalWrapper open={open} onClose={handleCloseModal} className={classes.paper}>
      {modalContentNode ? (
        <>{modalContentNode}</>
      ) : props.type === AssociationsType.IMPACTS ? (
        <ImpactsModal {...props} />
      ) : props.type === AssociationsType.JOURNEYS ? (
        <JourneysModal {...props} />
      ) : props.type === AssociationsType.STEPS ? (
        <StepsModal {...props} />
      ) : props.type === AssociationsType.PRODUCTS ? (
        <ProductsModal {...props} />
      ) : props.type === AssociationsType.ACCOUNTS ? (
        <AccountsModal handleClose={handleCloseModal} {...props} />
      ) : props.type === AssociationsType.IMPACTSWITHACTION ? (
        <ImpactsWithActionsModal {...props} />
      ) : null}
    </ModalWrapper>
  )
}

export { AssociationsModal, type IAssociationModalProps }
